export default {
  text: `    It's satisfying to come back for a few minutes every day and work on building up this wild, untamed world together. We're currently working to figure out what resources we need to combine to invent what we need to kill black wolves so we can explore deeper into the woods.`,
  author: "Cedric"
};
